import { sb } from '../../supabase.ts';
import { escapeHtml } from '../../main.ts';

export async function renderOtherSchoolResultEntryPage(app: HTMLElement): Promise<void> {
  const tableNameStudent = 'student_database_others';
  const tableNameExam = 'exam_others_school';
  const currentUser = localStorage.getItem('adminButton') || '';

  // Setup basic HTML template with custom CSS styling matching the glassmorphic database panel
  app.innerHTML = `
    <style>
      .re-wrap {
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.04), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        color: #334155;
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        min-height: 100vh;
        padding-bottom: 60px;
      }
      .re-header {
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(8px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding: 14px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .re-header h1 {
        font-size: 20px;
        margin: 0;
        font-weight: 850;
        color: #0f172a;
      }
      .back-btn {
        color: #10b981;
        text-decoration: none;
        margin-right: 12px;
        font-size: 20px;
        font-weight: bold;
        transition: transform 0.2s;
        display: inline-block;
      }
      .back-btn:hover {
        transform: translateX(-3px);
      }
      .re-container {
        padding: 24px;
        max-width: 960px;
        margin: 0 auto;
      }
      .card-section {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 24px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
      }
      .card-section h3 {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        padding-bottom: 8px;
      }
      .form-group {
        display: flex;
        flex-direction: column;
        margin-bottom: 14px;
        flex: 1;
      }
      .form-group label {
        font-size: 12px;
        font-weight: 700;
        color: #64748b;
        margin-bottom: 6px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      input[type=text], input[type=number] {
        padding: 10px 14px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 6px;
        font-size: 14px;
        color: #0f172a;
        outline: none;
        transition: border-color 0.2s, box-shadow 0.2s;
      }
      input:focus {
        border-color: #10b981;
        box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
      }
      input[type=number]::-webkit-outer-spin-button, 
      input[type=number]::-webkit-inner-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
      }
      input[type=number] { -moz-appearance: textfield; appearance: textfield; }
      .row {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
      }
      .btn {
        padding: 10px 20px;
        font-size: 14px;
        border-radius: 8px;
        font-weight: 700;
        cursor: pointer;
        border: none;
        transition: all 0.2s, transform 0.1s;
        color: #ffffff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
      }
      .btn:active {
        transform: scale(0.98);
      }
      .btn:hover {
        opacity: 0.95;
        transform: translateY(-1px);
      }
      .btn.primary {
        background: linear-gradient(135deg, #10b981, #059669);
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.15);
      }
      .btn.secondary {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.12);
        color: #475569;
      }
      .btn.secondary:hover {
        background: #f8fafc;
        border-color: rgba(0, 0, 0, 0.2);
        color: #0f172a;
      }
      .btn.danger {
        background: linear-gradient(135deg, #ef4444, #dc2626);
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.15);
      }
      .btn.warning {
        background: linear-gradient(135deg, #f59e0b, #d97706);
        box-shadow: 0 4px 12px rgba(245, 158, 11, 0.15);
      }
      .btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
      .status {
        font-size: 13.5px;
        margin-top: 8px;
        min-height: 20px;
        color: #64748b;
      }
      .status.ok {
        color: #10b981;
        font-weight: 600;
      }
      .status.err {
        color: #ef4444;
        font-weight: 600;
      }
      .readonly-field {
        background: #f1f5f9;
        border: 1px solid rgba(0, 0, 0, 0.08);
        padding: 10px 14px;
        border-radius: 6px;
        font-size: 14px;
        color: #0f172a;
        min-height: 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
      }
      .subject-grid {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-top: 16px;
      }
      .subject-card {
        background: #f8fafc;
        border: 1px solid rgba(0, 0, 0, 0.06);
        border-radius: 8px;
        padding: 14px 18px;
        display: grid;
        grid-template-columns: 240px repeat(auto-fit, minmax(110px, 1fr));
        gap: 16px;
        align-items: center;
      }
      .subject-card h4 {
        margin: 0;
        font-size: 14.5px;
        color: #10b981;
        font-weight: 700;
      }
      .subject-card .form-group {
        margin-bottom: 0;
      }
      .subject-card .form-group label {
        font-size: 11px;
        margin-bottom: 4px;
      }
      .subject-card input {
        padding: 8px 12px;
        font-size: 13.5px;
      }
      .subject-card .readonly-field {
        padding: 8px 12px;
        font-size: 13.5px;
        min-height: 36px;
      }
      .gpa-input {
        width: 80px;
        text-align: center;
      }
      .gpa-display {
        font-weight: 700;
        color: #10b981;
      }
      .login-warning {
        background: rgba(245, 158, 11, 0.15);
        border: 1px solid rgba(245, 158, 11, 0.3);
        color: #f59e0b;
        padding: 12px;
        border-radius: 8px;
        margin-bottom: 16px;
        font-size: 14px;
      }
    </style>

    <div class="re-wrap">
      <header class="re-header">
        <div style="display: flex; align-items: center;">
          <a href="/other_school_dashboard" class="back-btn">⬅</a>
          <h1>📊 Result Entry — General (Class 1-8)</h1>
        </div>
      </header>

      <div class="re-container">
        <!-- Login Alert if not set -->
        <div id="loginWarning" class="login-warning" style="display: none;">
          ⚠️ <strong>Login Required:</strong> You are not logged in. Result submission might be blocked.
        </div>

        <!-- Step 1: Load Student -->
        <div class="card-section">
          <h3>Step 1: Load Student Information</h3>
          <div class="row" style="align-items: flex-end;">
            <div class="form-group" style="max-width: 250px;">
              <label for="iidInput">Student IID</label>
              <input type="number" id="iidInput" placeholder="Enter IID (e.g. 10001)"/>
            </div>
            <div>
              <button id="loadBtn" class="btn primary">Load Student</button>
            </div>
          </div>
          <div id="loadStatus" class="status"></div>
        </div>

        <!-- Step 2: Student Details -->
        <div id="studentInfoSection" class="card-section" style="display: none;">
          <h3>Step 2: Verify Student Profile & Session Details</h3>
          <div class="row" style="margin-bottom: 16px;">
            <div class="form-group">
              <label>Student Name</label>
              <div id="studentNameDisplay" class="readonly-field">-</div>
            </div>
            <div class="form-group">
              <label>Father's Name</label>
              <div id="fatherNameDisplay" class="readonly-field">-</div>
            </div>
            <div class="form-group">
              <label>Father's Mobile</label>
              <div id="fatherMobileDisplay" class="readonly-field">-</div>
            </div>
            <div class="form-group">
              <label>Record Owner</label>
              <div id="studentOwnerDisplay" class="readonly-field">-</div>
            </div>
          </div>
          
          <div class="row">
            <div class="form-group">
              <label for="class2025Input">Class</label>
              <input type="text" id="class2025Input" placeholder="e.g., Six" value="Six" />
            </div>
            <div class="form-group">
              <label for="section2025Input">Section</label>
              <input type="text" id="section2025Input" placeholder="e.g., Shapla" value="Shapla" />
            </div>
            <div class="form-group">
              <label for="roll2025Input">Roll</label>
              <input type="number" id="roll2025Input" placeholder="Roll Number" />
            </div>
            <div class="form-group">
              <label for="examNameYearInput">Exam Name & Year</label>
              <input type="text" id="examNameYearInput" placeholder="e.g., Half Yearly 2025" value="Half Yearly 2025" />
            </div>
          </div>

          <div style="margin-top: 18px;">
            <button id="proceedBtn" class="btn primary">Proceed to Marks Entry</button>
            <div id="proceedStatus" class="status"></div>
          </div>
        </div>

        <!-- Step 3: Marks Grid -->
        <div id="marksEntrySection" class="card-section" style="display: none;">
          <h3>Step 3: Enter Subject Marks</h3>
          <div id="subjectGrid" class="subject-grid"></div>

          <!-- Overall Summary -->
          <div style="margin-top: 24px; padding: 18px; background: #f8fafc; border: 1px solid rgba(0, 0, 0, 0.06); border-radius: 8px;">
            <h4 style="margin-top: 0; margin-bottom: 12px; color: #0f172a;">📊 Overall Calculated Result</h4>
            <div class="row">
              <div class="form-group">
                <label>Total Marks</label>
                <div id="totalMarkDisplay" class="readonly-field" style="font-weight: 700; font-size: 16px;">-</div>
              </div>
              <div class="form-group">
                <label>Average</label>
                <div id="averageDisplay" class="readonly-field" style="font-weight: 700; font-size: 16px;">-</div>
              </div>
              <div class="form-group">
                <label>Final GPA</label>
                <div style="display: flex; gap: 8px; align-items: center;">
                  <input type="number" id="gpaFinalInput" class="gpa-input" step="0.01" min="0" max="5" placeholder="-" />
                  <button id="gpaAutoBtn" type="button" class="btn secondary" style="padding: 8px 12px; font-size: 12px; height: 38px;">Auto</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Class Rank and Remarks -->
          <div class="row" style="margin-top: 20px;">
            <div class="form-group" style="max-width: 160px;">
              <label for="class_rank">Class Rank</label>
              <input type="number" id="class_rank" min="0" step="1" placeholder="e.g. 1" />
            </div>
            <div class="form-group">
              <label for="remark">Remarks / Recommendations</label>
              <input type="text" id="remark" placeholder="e.g. Excellent progress" />
            </div>
          </div>

          <!-- Database Actions -->
          <div style="margin-top: 24px; display: flex; gap: 12px;">
            <button id="saveBtn" class="btn primary">💾 Save Result</button>
            <button id="clearBtn" class="btn warning">🔄 Clear Form</button>
          </div>
          <div id="saveStatus" class="status"></div>

          <!-- Input User Footer Info -->
          <div style="margin-top: 20px; border-top: 1px solid rgba(0, 0, 0, 0.05); padding-top: 12px;">
            <label style="font-size: 12px; font-weight: 700; color: #64748b; text-transform: uppercase;">Last Input User</label>
            <div id="inputUserDisplay" style="color: #0f172a; font-size: 13.5px; margin-top: 4px;">-</div>
          </div>
        </div>
      </div>
    </div>
  `;

  // Fetch DOM Elements
  const loginWarning = document.getElementById('loginWarning') as HTMLDivElement;
  const iidInput = document.getElementById('iidInput') as HTMLInputElement;
  const loadBtn = document.getElementById('loadBtn') as HTMLButtonElement;
  const loadStatus = document.getElementById('loadStatus') as HTMLDivElement;

  const studentInfoSection = document.getElementById('studentInfoSection') as HTMLDivElement;
  const studentNameDisplay = document.getElementById('studentNameDisplay') as HTMLDivElement;
  const fatherNameDisplay = document.getElementById('fatherNameDisplay') as HTMLDivElement;
  const fatherMobileDisplay = document.getElementById('fatherMobileDisplay') as HTMLDivElement;
  const studentOwnerDisplay = document.getElementById('studentOwnerDisplay') as HTMLDivElement;

  const class2025Input = document.getElementById('class2025Input') as HTMLInputElement;
  const section2025Input = document.getElementById('section2025Input') as HTMLInputElement;
  const roll2025Input = document.getElementById('roll2025Input') as HTMLInputElement;
  const examNameYearInput = document.getElementById('examNameYearInput') as HTMLInputElement;

  const proceedBtn = document.getElementById('proceedBtn') as HTMLButtonElement;
  const proceedStatus = document.getElementById('proceedStatus') as HTMLDivElement;

  const marksEntrySection = document.getElementById('marksEntrySection') as HTMLDivElement;
  const saveBtn = document.getElementById('saveBtn') as HTMLButtonElement;
  const clearBtn = document.getElementById('clearBtn') as HTMLButtonElement;
  const saveStatus = document.getElementById('saveStatus') as HTMLDivElement;
  const inputUserDisplay = document.getElementById('inputUserDisplay') as HTMLDivElement;

  const totalMarkDisplay = document.getElementById('totalMarkDisplay') as HTMLDivElement;
  const averageDisplay = document.getElementById('averageDisplay') as HTMLDivElement;
  const gpaFinalInput = document.getElementById('gpaFinalInput') as HTMLInputElement;
  const gpaAutoBtn = document.getElementById('gpaAutoBtn') as HTMLButtonElement;

  const classRankInput = document.getElementById('class_rank') as HTMLInputElement;
  const remarkInput = document.getElementById('remark') as HTMLInputElement;

  // Verify authorization warning
  if (!currentUser) {
    loginWarning.style.display = 'block';
  }

  // Active state holders
  let currentIID: number | null = null;
  let currentStudentData: any = null;
  let finalGpaManual = false;

  // Universal GPA calculation mapping
  function calculateGPA(marks: number | null): number | null {
    if (marks === null || marks === undefined || isNaN(marks)) return null;
    if (marks >= 80) return 5.0;
    if (marks >= 70) return 4.0;
    if (marks >= 60) return 3.5;
    if (marks >= 50) return 3.0;
    if (marks >= 40) return 2.0;
    if (marks >= 33) return 1.0;
    return 0.0;
  }

  // Legacy Subjects definition
  interface Subject {
    id: string;
    db: string;
    label: string;
    parts: string[];
    gpa: boolean;
  }

  const SUBJECTS: Subject[] = [
    { id: 'bangla1', db: '*Bangla 1st Paper', label: 'Bangla 1st Paper', parts: ['CQ', 'MCQ'], gpa: true },
    { id: 'bangla2', db: '*Bangla 2nd Paper', label: 'Bangla 2nd Paper', parts: ['CQ', 'MCQ'], gpa: false },
    { id: 'english1', db: '*English 1st Paper', label: 'English 1st Paper', parts: ['CQ'], gpa: true },
    { id: 'english2', db: '*English 2nd Paper', label: 'English 2nd Paper', parts: ['CQ'], gpa: false },
    { id: 'math', db: '*Mathematics', label: 'Mathematics', parts: ['CQ', 'MCQ'], gpa: true },
    { id: 'religion', db: '*Religion', label: 'Religion', parts: ['CQ', 'MCQ'], gpa: true },
    { id: 'science', db: '*Science', label: 'Science', parts: ['CQ', 'MCQ'], gpa: true },
    { id: 'ict', db: '*ICT', label: 'ICT', parts: ['MCQ', 'Practical'], gpa: true },
    { id: 'bgs', db: '*Bangladesh And Global Studies', label: 'Bangladesh And Global Studies', parts: ['CQ', 'MCQ'], gpa: true }
  ];

  // Dynamic layout renderer
  function renderSubjectGrid() {
    const grid = document.getElementById('subjectGrid');
    if (!grid) return;
    grid.innerHTML = '';

    SUBJECTS.forEach(sub => {
      const card = document.createElement('div');
      card.className = 'subject-card';

      let html = `<h4>${escapeHtml(sub.label)}</h4>`;
      sub.parts.forEach(p => {
        const id = `${sub.id}_${p.toLowerCase()}`;
        html += `
          <div class="form-group">
            <label>${p}</label>
            <input type="number" id="${id}" min="0" max="100" step="0.01"/>
          </div>
        `;
      });

      html += `
        <div class="form-group">
          <label>Total</label>
          <div id="${sub.id}_total" class="readonly-field"></div>
        </div>
      `;

      if (sub.gpa) {
        html += `
          <div class="form-group">
            <label>GPA</label>
            <input type="number" id="${sub.id}_gpa" class="gpa-input" step="0.1" min="0" max="5" placeholder="-"/>
          </div>
        `;
      }

      card.innerHTML = html;
      grid.appendChild(card);
    });
  }

  // Calculate totals and GPAs
  function calculateOverall() {
    const ids = ['bangla1_total', 'bangla2_total', 'english1_total', 'english2_total', 'math_total', 'religion_total', 'science_total', 'ict_total', 'bgs_total'];
    let totalMark = 0;
    let filledCount = 0;

    ids.forEach(id => {
      const el = document.getElementById(id);
      const t = el ? el.textContent?.trim() : '';
      if (t) {
        const v = parseFloat(t);
        if (!isNaN(v)) {
          totalMark += v;
          filledCount++;
        }
      }
    });

    if (filledCount > 0) {
      totalMarkDisplay.textContent = totalMark.toFixed(2);
      averageDisplay.textContent = (totalMark / filledCount).toFixed(2);
    } else {
      totalMarkDisplay.textContent = '-';
      averageDisplay.textContent = '-';
    }

    // Average GPAs
    const gpaIds = ['bangla1_gpa', 'english1_gpa', 'math_gpa', 'religion_gpa', 'science_gpa', 'ict_gpa', 'bgs_gpa'];
    const gpas = gpaIds.map(id => {
      const el = document.getElementById(id) as HTMLInputElement;
      const v = el ? el.value : '';
      const n = parseFloat(v);
      return !isNaN(n) ? n : null;
    }).filter((g): g is number => g !== null);

    const finalGPA = gpas.length > 0 ? (gpas.reduce((a, b) => a + b, 0) / gpas.length) : 0;
    if (!finalGpaManual) {
      if (finalGPA > 0) {
        gpaFinalInput.value = finalGPA.toFixed(2);
        gpaFinalInput.classList.add('gpa-display');
      } else {
        gpaFinalInput.value = '';
        gpaFinalInput.classList.remove('gpa-display');
      }
    }
  }

  function setupAutoCalculations() {
    renderSubjectGrid();

    SUBJECTS.forEach(sub => {
      const parts = sub.parts.map(p => `${sub.id}_${p.toLowerCase()}`);
      const totalId = `${sub.id}_total`;
      const gpaId = sub.gpa ? `${sub.id}_gpa` : null;

      function recalc() {
        const hasAnyInput = parts.some(pid => {
          const el = document.getElementById(pid) as HTMLInputElement;
          return el && el.value.trim() !== '';
        });

        const totalEl = document.getElementById(totalId);
        if (!hasAnyInput) {
          if (totalEl) totalEl.textContent = '';
          if (gpaId) {
            const gel = document.getElementById(gpaId) as HTMLInputElement;
            if (gel) gel.value = '';
          }
          calculateOverall();
          return;
        }

        let sum = 0;
        parts.forEach(pid => {
          const el = document.getElementById(pid) as HTMLInputElement;
          const v = el ? parseFloat(el.value) || 0 : 0;
          sum += v;
        });

        if (totalEl) totalEl.textContent = sum.toFixed(2);

        if (gpaId) {
          const gel = document.getElementById(gpaId) as HTMLInputElement;
          if (gel) {
            const g = calculateGPA(sum);
            gel.value = g !== null ? g.toFixed(1) : '';
          }
        }

        calculateOverall();
      }

      parts.forEach(pid => {
        const el = document.getElementById(pid);
        if (el) el.addEventListener('input', recalc);
      });
    });

    // Wire manually input custom GPAs
    document.querySelectorAll('.gpa-input').forEach(el => {
      el.addEventListener('input', () => { calculateOverall(); });
    });
  }

  function loadSubjectsToForm(examData: any) {
    SUBJECTS.forEach(sub => {
      sub.parts.forEach(p => {
        const key = sub.db + '_' + p;
        const el = document.getElementById(`${sub.id}_${p.toLowerCase()}`) as HTMLInputElement;
        if (el && examData[key] !== undefined && examData[key] !== null) {
          el.value = examData[key];
        }
      });

      if (sub.gpa) {
        const gpakey = sub.db + '_GPA';
        const el = document.getElementById(`${sub.id}_gpa`) as HTMLInputElement;
        if (el && examData[gpakey] !== undefined && examData[gpakey] !== null) {
          el.value = String(examData[gpakey]);
        }
      }
    });

    // Trigger recalculation change events
    SUBJECTS.forEach(sub => {
      sub.parts.forEach(p => {
        const el = document.getElementById(`${sub.id}_${p.toLowerCase()}`);
        if (el) el.dispatchEvent(new Event('input'));
      });
    });
  }

  function gatherSubjectPayload(): Record<string, any> {
    const out: Record<string, any> = {};
    SUBJECTS.forEach(sub => {
      sub.parts.forEach(p => {
        const key = sub.db + '_' + p;
        const id = `${sub.id}_${p.toLowerCase()}`;
        const el = document.getElementById(id) as HTMLInputElement;
        out[key] = (el && el.value.trim() !== '') ? parseFloat(el.value) : null;
      });

      const totalEl = document.getElementById(`${sub.id}_total`);
      const totalText = totalEl ? totalEl.textContent?.trim() : '';
      out[sub.db + '_Total'] = (totalText && totalText !== '') ? parseFloat(totalText) : null;

      if (sub.gpa) {
        const el = document.getElementById(`${sub.id}_gpa`) as HTMLInputElement;
        out[sub.db + '_GPA'] = (el && el.value.trim() !== '') ? el.value.trim() : null;
      }
    });
    return out;
  }

  async function loadExistingExamData(iid: number) {
    try {
      const { data, error } = await sb.from(tableNameExam).select('*').eq('iid', iid);
      if (error) throw error;

      if (data && data.length > 0) {
        const examData = data[0];

        class2025Input.value = examData.class_2025 || '';
        section2025Input.value = examData.section_2025 || '';
        roll2025Input.value = examData.roll_2025 || '';
        examNameYearInput.value = examData.exam_name_year || '';

        // Load subjects
        loadSubjectsToForm(examData);

        // Class rank and remark
        classRankInput.value = examData.class_rank || '';
        remarkInput.value = examData.remark || '';

        if (examData.input_user_name) {
          inputUserDisplay.textContent = examData.input_user_name;
        }

        if (examData.total_mark !== null) totalMarkDisplay.textContent = parseFloat(examData.total_mark).toFixed(2);
        if (examData.average_mark !== null) averageDisplay.textContent = parseFloat(examData.average_mark).toFixed(2);

        if (examData.gpa_final !== null && examData.gpa_final !== '') {
          gpaFinalInput.value = parseFloat(examData.gpa_final).toFixed(2);
          gpaFinalInput.classList.add('gpa-display');
          finalGpaManual = true;
        } else {
          finalGpaManual = false;
        }

        marksEntrySection.style.display = 'block';
        proceedStatus.textContent = '✅ Existing exam data loaded!';
        proceedStatus.className = 'status ok';
      }
    } catch (e: any) {
      console.log('No existing exam data:', e.message);
    }
  }

  // Load Button Trigger
  loadBtn.onclick = async () => {
    const iid = parseInt(iidInput.value);
    if (!iid || isNaN(iid)) {
      loadStatus.textContent = '❌ Please enter a valid student IID';
      loadStatus.className = 'status err';
      return;
    }

    loadStatus.textContent = '🔄 Fetching student info...';
    loadStatus.className = 'status';
    loadBtn.disabled = true;

    try {
      const { data, error } = await sb.from(tableNameStudent).select('*').eq('iid', iid);
      if (error) throw error;

      if (!data || data.length === 0) {
        loadStatus.textContent = '❌ Student not found in others database';
        loadStatus.className = 'status err';
        loadBtn.disabled = false;
        return;
      }

      const student = data[0];
      currentIID = iid;
      currentStudentData = student;

      studentNameDisplay.textContent = student.student_name_en || '-';
      fatherNameDisplay.textContent = student.father_name_en || '-';
      fatherMobileDisplay.textContent = student.father_mobile || '-';
      studentOwnerDisplay.textContent = student.input_user_name || '-';

      // Load session filters
      class2025Input.value = student.class_2025 || 'Six';
      section2025Input.value = student.section_2025 || 'Shapla';
      roll2025Input.value = student.roll_2025 || '';

      // Check Owner Authorization
      let ownerConflict = false;
      const owner = student.input_user_name || null;
      if (owner && currentUser && owner !== currentUser) {
        loadStatus.textContent = `❌ Authorization conflict. Owner is: ${owner}`;
        loadStatus.className = 'status err';
        ownerConflict = true;
      }

      if (ownerConflict) {
        proceedBtn.disabled = true;
        saveBtn.disabled = true;
        marksEntrySection.style.display = 'none';
      } else {
        proceedBtn.disabled = false;
        saveBtn.disabled = false;
      }

      studentInfoSection.style.display = 'block';
      loadStatus.textContent = '✅ Profile loaded successfully!';
      loadStatus.className = 'status ok';
      loadBtn.disabled = false;

      // Load existing result data
      await loadExistingExamData(iid);

    } catch (e: any) {
      loadStatus.textContent = '❌ Error loading: ' + e.message;
      loadStatus.className = 'status err';
      loadBtn.disabled = false;
    }
  };

  // Bind Enter key inside IID input
  iidInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      loadBtn.click();
    }
  });

  // Proceed button trigger
  proceedBtn.onclick = () => {
    const cls = class2025Input.value.trim();
    const sec = section2025Input.value.trim();
    const roll = roll2025Input.value.trim();
    const exName = examNameYearInput.value.trim();

    if (!cls || !sec || !roll || !exName) {
      proceedStatus.textContent = '❌ Please fill all class, section, roll, and exam fields';
      proceedStatus.className = 'status err';
      return;
    }

    if (currentStudentData && currentStudentData.input_user_name && currentUser && currentStudentData.input_user_name !== currentUser) {
      proceedStatus.textContent = '❌ Not authorized to proceed. Owned by: ' + currentStudentData.input_user_name;
      proceedStatus.className = 'status err';
      marksEntrySection.style.display = 'none';
      return;
    }

    marksEntrySection.style.display = 'block';
    proceedStatus.textContent = '✅ Form initialized for entry!';
    proceedStatus.className = 'status ok';
  };

  // Save button trigger
  saveBtn.onclick = async () => {
    if (!currentIID) {
      saveStatus.textContent = '❌ Load student profile first';
      saveStatus.className = 'status err';
      return;
    }

    if (currentStudentData && currentStudentData.input_user_name && currentUser && currentStudentData.input_user_name !== currentUser) {
      saveStatus.textContent = '❌ Not authorized. Owned by: ' + currentStudentData.input_user_name;
      saveStatus.className = 'status err';
      return;
    }

    saveStatus.textContent = '💾 Saving result to database...';
    saveStatus.className = 'status';
    saveBtn.disabled = true;

    const payload = {
      iid: currentIID,
      class_2025: class2025Input.value.trim(),
      section_2025: section2025Input.value.trim(),
      roll_2025: roll2025Input.value.trim() ? parseFloat(roll2025Input.value) : null,
      student_name_en: currentStudentData.student_name_en,
      father_name_en: currentStudentData.father_name_en,
      father_mobile: currentStudentData.father_mobile || null,
      exam_name_year: examNameYearInput.value.trim(),
      class_rank: classRankInput.value.trim() ? parseFloat(classRankInput.value) : null,
      remark: remarkInput.value.trim() || null,
      input_user_name: currentUser || null,
      total_mark: totalMarkDisplay.textContent && totalMarkDisplay.textContent !== '-' ? parseFloat(totalMarkDisplay.textContent) : null,
      average_mark: averageDisplay.textContent && averageDisplay.textContent !== '-' ? parseFloat(averageDisplay.textContent) : null,
      gpa_final: gpaFinalInput.value !== '' ? parseFloat(gpaFinalInput.value) : null,
      ...gatherSubjectPayload()
    };

    try {
      const { error } = await sb.from(tableNameExam).upsert(payload, { onConflict: 'iid' }).select();
      if (error) throw error;

      saveStatus.textContent = '✅ Result saved successfully!';
      saveStatus.className = 'status ok';
    } catch (e: any) {
      saveStatus.textContent = '❌ Database save error: ' + e.message;
      saveStatus.className = 'status err';
    } finally {
      saveBtn.disabled = false;
    }
  };

  // Clear Form Trigger
  clearBtn.onclick = () => {
    if (confirm('Clear all mark input fields? Roll & student details are kept.')) {
      document.querySelectorAll('#subjectGrid input[type=number]').forEach(el => {
        (el as HTMLInputElement).value = '';
      });

      remarkInput.value = '';
      finalGpaManual = false;
      gpaFinalInput.value = '';
      gpaFinalInput.classList.remove('gpa-display');

      // Trigger redraw
      SUBJECTS.forEach(sub => {
        sub.parts.forEach(p => {
          const el = document.getElementById(`${sub.id}_${p.toLowerCase()}`);
          if (el) el.dispatchEvent(new Event('input'));
        });
      });

      saveStatus.textContent = '🔄 Form cleared';
      saveStatus.className = 'status';
    }
  };

  // GPA Auto Button Trigger
  gpaFinalInput.addEventListener('input', () => {
    finalGpaManual = true;
    if (gpaFinalInput.value !== '') gpaFinalInput.classList.add('gpa-display');
    else gpaFinalInput.classList.remove('gpa-display');
  });

  gpaAutoBtn.onclick = () => {
    finalGpaManual = false;
    calculateOverall();
    saveStatus.textContent = '🔄 Auto-calculated GPA enabled';
    saveStatus.className = 'status';
  };

  // Auto setup calculations
  setupAutoCalculations();

  // If iid query param is passed, auto load student
  const urlIid = new URLSearchParams(window.location.search).get('iid');
  if (urlIid) {
    iidInput.value = urlIid;
    loadBtn.click();
  }
}
